export default {
    parametrosSistema: (state) => state.parametros,
    ehClienteMS: (state) => state.parametros.cliente === 'MS'
}
